import styled from "styled-components/macro";
import HomeBack from "../../../images/signbgFull.png";
const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";

export const SignInContainer = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 96px;
  background: url(${HomeBack}) no-repeat center top / cover;
`;

export const SignRow = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  max-width: 1333px;

  ${
    "" /* @media screen and (max-width :1562px) {
        width: 88%;
    }

    @media screen and (max-width :1500px) {
        width: 93%;
    } */
  }

  @media screen and (max-width :768px) {
    grid-template-areas: auto auto;
  }
`;

export const SignColumn1 = styled.div`
  /* height: 100vh; */
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;

  @media (max-width: 1366px) {
    align-items: center;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SignColumn2 = styled.div`
  /* height: 100vh; */
  width: 50%;
  display: flex;
  justify-content: right;
  align-items: center;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const ImageWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin-top: 10rem;
`;

export const LivingImage = styled.img`
  height: auto;
  width: 100%;
`;

export const SigninDetailsWrap = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 68% ${"" /* padding : 0rem 16rem; */};
`;

export const LoginTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LoginHeading = styled.h2`
  color: #000000;
  font-size: 1.6rem;
  /* text-align: left; */
  ${"" /* text-align: ${({ alignCenter }) => (alignCenter ? 'center' : 'left')}; */}
  ${"" /* font-weight: bold; */}
    
    @media screen and (max-width: 768px) {
    font-size: 1.6em;
  }

  @media screen and (max-width: 480px) {
    font-size: 1.3em;
  }
`;

export const SignHeadingOne = styled.div`
  font: normal normal medium 16px/22px Montserrat;
  text-align: left;
  letter-spacing: 2.56px;
  color: #ff9900;
  text-transform: uppercase;
  opacity: 1;
`;

export const SigninWelcome = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const SigninWelcomeHeading = styled.div`
  color: #000000;
  opacity: 1;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-right: 0.8rem;
  font-size: 2.1rem;
  margin-top: 0.4rem;
  font-weight: 700;
`;

export const SigninWelcomeIcon = styled.img`
  height: 35px;
  width: 35px;
`;

export const SignInform = styled.div`
  margin-top: 1.8rem;
`;

export const SignInButton = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
`;

export const RoleWrap = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const RoleWrapBtn = styled.button`
  padding: 0rem 1rem;
  height: 40px;
  background: ${({ role }) => (role ? "#004CFF" : "#E6E6E6")};
  color: ${({ role }) => (role ? "white" : "black")};
  border-radius: 4px;
  opacity: 1;
  border: none;
  margin-left: 20px;
  cursor: pointer;
`;

export const SignupDetailsWrap = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  ${"" /* padding : 0rem 16rem; */}
`;

export const SocialCorner = styled.div`
  position: fixed;
  top: 38%;
  right: ${defaultLanguage === "ar" ? "" : "3rem"};
  left: ${defaultLanguage === "ar" ? "3rem" : ""};
  z-index: 99;
  /* @media screen and (max-width: 1550px) {
    right: 2rem;
  } */

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const SocialCornerButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const SocialBoxWrap = styled.div`
  margin: 0.7rem 0rem;
`;

export const SocialBox = styled.img`
  height: 23px;
  width: 23px;

  @media screen and (max-width: 1024px) {
    height: 20px;
    width: 20px;
  }
`;

export const ApprovalBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const ApprovalImg = styled.img`
  width: 50%;
`;

export const DisApprovalImg = styled.img`
  width: 30%;
`;

export const ApprovalText = styled.div`
  font-weight: 600;
  font-size: 1rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  color: #111111;
  opacity: 1;

  @media screen and (max-width: 425px) {
    font-size: 0.9rem;
  }

  @media screen and (max-width: 375px) {
    font-size: 0.7rem;
  }
  /* margin-top: 1rem; */
`;

export const ApprovalDesc = styled.div`
  font-weight: 400;
  font-size: 0.8rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  color: #111111;
  opacity: 0.5;
  margin-top: 0.5rem;

  @media screen and (max-width: 425px) {
    font-size: 0.7rem;
  }

  @media screen and (max-width: 375px) {
    font-size: 0.6rem;
    margin-top: 0rem;
  }
`;

export const ApprovalDescTwo = styled.div`
  font-weight: 400;
  font-size: 0.8rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  color: #111111;
  opacity: 0.5;

  @media screen and (max-width: 425px) {
    font-size: 0.7rem;
    margin-top: 0rem;
  }

  @media screen and (max-width: 375px) {
    font-size: 0.6rem;
    margin-top: 0rem;
  }
`;

export const ApprovalButton = styled.div`
  margin-top: 1.5rem;
  width: 100%;
`;

export const PropertyButton = styled.div`
  margin-top: 0.5rem;
  width: 100%;
`;

export const HomeBox = styled.div`
  margin-top: 1.5em;
  display: flex;
  justify-content: center;
`;

export const WebsiteText = styled.div`
  font-weight: 600;
  font-size: 1.3rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-top: 1rem;
`;

export const MoreWebsiteButton = styled.button`
  margin: 0.4em;
  border-radius: 2px;
  width: 100%;
  white-space: nowrap;
  padding: ${({ big }) => (big ? "0.5em 2em" : "0.3em 1.5em")};
  background: #004cff1a 0% 0% no-repeat padding-box;
  border: 1px solid #004cff;
  color: #004cff;
  font-size: ${({ fontBig }) => (fontBig ? "1.2rem" : "1rem")};
  outline: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  border-radius: 4px;
  margin-bottom: 0.8rem;

  @media screen and (max-width: 768px) {
    margin: 0.5em;
    margin-left: 0;
    padding: ${({ big }) => (big ? "0.5em 2em" : "0.6em 1.5em")};
    font-size: ${({ fontBig }) => (fontBig ? "1.2em" : "0.9em")};
  }

  @media screen and (max-width: 480px) {
    margin: 0.5em;
    margin-left: 0;
    padding: ${({ big }) => (big ? "0.5em 2em" : "0.4em 1.2em")};
    font-size: ${({ fontBig }) => (fontBig ? "1.2em" : "0.8em")};
  }
`;

export const MoreWebsiteText = styled.div`
  font-weight: 500;
  font-size: 0.8rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  color: #004cff;
  opacity: 1;
`;

export const NotText = styled.div`
  font-weight: 500;
  font-size: 0.8rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  color: #f32a2a;
  opacity: 1;
  margin: 1rem 0rem;
  cursor: pointer;

  @media screen and (max-width: 425px) {
    font-size: 0.9rem;
  }

  @media screen and (max-width: 375px) {
    font-size: 0.7rem;
  }
  /* margin-top: 1rem; */
`;

export const PurchaseDesc = styled.div`
  font-weight: 500;
  font-size: 0.9rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  color: #8e8e8f;
  opacity: 0.8;

  @media screen and (max-width: 425px) {
    font-size: 0.7rem;
  }

  @media screen and (max-width: 375px) {
    font-size: 0.6rem;
    margin-top: 0rem;
  }
`;
